import * as React from 'react';
import { cn } from '@relay-towing/tokens';
import { iconFanCardRecipe, iconFanRecipe } from '../recipes/mobile.recipe';
import { Icon, type IconComponent, type IconProps } from './Icon';

export interface IconFanItem {
  icon: IconComponent;
  /** What the card stands for, read out: "Notifications". */
  label: string;
  /** The glyph's colour. */
  tone?: IconProps['tone'];
}

export interface IconFanProps extends React.HTMLAttributes<HTMLUListElement> {
  items: IconFanItem[];
}

/**
 * A fanned row of icon cards: what the app is about to ask for, as the
 * Figma's Welcome to Relay draws the phone's permissions. Each card is
 * named for a screen reader, so the row reads as a list of what is asked.
 *
 *   <IconFan items={[
 *     { icon: Notification, label: 'Notifications', tone: 'info' },
 *     { icon: Camera, label: 'Camera', tone: 'warning' },
 *   ]} />
 */
export const IconFan = React.forwardRef<HTMLUListElement, IconFanProps>(
  function IconFan({ items, className, ...props }, ref) {
    return (
      <ul ref={ref} className={cn(iconFanRecipe(), className)} {...props}>
        {items.map(({ icon, label, tone }) => (
          <li key={label} className={iconFanCardRecipe()} aria-label={label}>
            <Icon icon={icon} size="lg" tone={tone} />
          </li>
        ))}
      </ul>
    );
  }
);
